'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/bell/BellIcon.tsx
import { jsx } from "react/jsx-runtime";
var BellIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.47242 2.18834L3.93623 2.82626C3.12633 3.78985 2.54262 4.94805 2.26503 6.21974L2.08731 7.0339L0.458984 6.67846L0.636706 5.8643C0.973401 4.32185 1.68109 2.919 2.66038 1.75389L3.19657 1.11597L4.47242 2.18834ZM16.8026 1.11597L17.3388 1.75389C18.3181 2.919 19.0257 4.32185 19.3624 5.8643L19.5402 6.67846L17.9118 7.0339L17.7341 6.21974C17.4565 4.94805 16.8728 3.78984 16.0629 2.82627L15.5267 2.18834L16.8026 1.11597ZM3.51273 7.34605C3.94623 4.09483 6.71958 1.66672 9.99957 1.66672C13.2796 1.66672 16.0529 4.09483 16.4864 7.34605L17.6181 15.8334H13.8719C13.1216 17.2871 11.6973 18.3334 9.99957 18.3334C8.30182 18.3334 6.87755 17.2871 6.12719 15.8334H2.38109L3.51273 7.34605ZM8.14836 15.8334C8.65574 16.3653 9.31211 16.6667 9.99957 16.6667C10.687 16.6667 11.3434 16.3653 11.8508 15.8334H8.14836ZM9.99957 3.33338C7.55491 3.33338 5.48787 5.14311 5.16478 7.56632L4.28472 14.1667H15.7144L14.8344 7.56633C14.5113 5.14311 12.4442 3.33338 9.99957 3.33338Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  BellIcon
};
//# sourceMappingURL=chunk-KABRS5JJ.mjs.map